<div class="d-flex flex-column align-items-center mt-9 align-text-center">
  <ng-container [ngSwitch]="true">
    <ng-container *ngSwitchCase="statusCode == '403'">
      <p>{{ 'FejlSide.403' | tekstresource }}</p>
    </ng-container>
    <ng-container *ngSwitchCase="statusCode == '404'">
      <p>{{ 'FejlSide.404' | tekstresource }}</p>
    </ng-container>
    <ng-container *ngSwitchCase="statusCode == '410'">
      <p>{{ 'FejlSide.410' | tekstresource }}</p>
    </ng-container>
    <ng-container *ngSwitchCase="statusCode === 'iat' || statusCode === 'exp'">
      <p [innerHTML]="'FejlSide.Ur1' | tekstresource"></p>
      <p [innerHTML]="'FejlSide.Ur2' | tekstresource"></p>
      <p [innerHTML]="'FejlSide.Ur3' | tekstresource"></p>
      <p [innerHTML]="'FejlSide.Ur4' | tekstresource"></p>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <p>{{ 'FejlSide.Tekst' | tekstresource }}</p>
    </ng-container>
  </ng-container>
  <p *ngIf=" correlationId">
    {{ 'FejlSide.CorrelationId' | tekstresource: { correlationId: correlationId } }}
  </p>
  <ng-container *ngIf="error$ | async as error">
    <p>Fejlbesked:</p>
    <pre>{{ error | json }}</pre>
  </ng-container>
  <p *ngIf="date">{{ date | displayDate: true }}</p>
  <a href="/">{{ 'FejlSide.LinkTekst' | tekstresource }}</a>
</div>